import { render, staticRenderFns } from "./InqueryOverview.vue?vue&type=template&id=0f4fdbb0&scoped=true&"
import script from "./InqueryOverview.vue?vue&type=script&lang=ts&"
export * from "./InqueryOverview.vue?vue&type=script&lang=ts&"
import style0 from "./InqueryOverview.vue?vue&type=style&index=0&id=0f4fdbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fdbb0",
  null
  
)

export default component.exports